import { Component, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from '../../services';
import { UserPanelModule } from '../user-panel/user-panel.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxDropDownButtonModule } from 'devextreme-angular/ui/drop-down-button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { DxFormModule } from 'devextreme-angular/ui/form';

import { UserModel } from 'src/app/models/user-model';
import { ResetPasswordModel } from 'src/app/models/reset-password-model';
import { FormItemControlService } from 'src/app/services/form-item-control.service';
import { formLayoutEnum } from 'src/app/services/formLayoutEnum';
import { CONFIG } from '../../../config/app.config';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title: string;
  viewMenuItems: any[];
  selectBoxOptions: any;
  helpButtonOptions: any;
  loginButtonOptions: any;
  logoffButtonOptions: any;
  userSettingsButtonOptions: any;
  showAbout: boolean;
  appName: string;
  version: string;
  releasedDate: string;
  bSupportResultsLayout: boolean;
  formItemControlService: FormItemControlService;
  isLoggedIn: boolean;
  showLoginDialog: boolean;
  showChangePasswordDialog: boolean;
  userModel: UserModel;
  resetPasswordModel: ResetPasswordModel;
  errorMsg: string;
  showErrorMsg: boolean;
  loggedInUser: string;
  userSettingsDropdownItems: string[];
  changePasswordIndex: number;
  isForcedChangePassword: boolean;

  constructor(private authService: AuthService,
              private fcs: FormItemControlService) {
    this.appName = CONFIG.appName;
    this.version = CONFIG.version;
    this.releasedDate = CONFIG.releasedDate;
    this.formItemControlService = fcs;

    this.showAbout = false;
    this.isLoggedIn = false;
    this.loggedInUser = '';
    this.showLoginDialog = false;
    this.showChangePasswordDialog = false;
    this.userModel = new UserModel();
    this.resetPasswordModel = new ResetPasswordModel();
    this.errorMsg = '';
    this.showErrorMsg = false;
    this.isForcedChangePassword = true;

    this.changePasswordIndex = 0;
    this.userSettingsDropdownItems = [ 'Change Password...' ];

    this.formItemControlService.getIsLoggedInObservable().subscribe(isLoggedIn => this.isLoggedIn = isLoggedIn);

    this.formItemControlService.getLoggedInUserObservable().subscribe(loggedInUser =>
      {
         this.loggedInUser = loggedInUser
         this.InitializeLogOffButton();
      });

   this.formItemControlService.getIsPasswordExpiredObservable().subscribe(isPasswordExpired => 
    { 
      this.showChangePasswordDialog = isPasswordExpired 
    });

    this.formItemControlService.getResultsLayoutSupportedObservable().subscribe(bSupported => this.populateViewMenu(bSupported));

    this.helpButtonOptions = {
        icon: 'info',
        hint: this.appName + ' ' + this.version,
        onClick: () => {
          this.showAbout = true;
        }
    };

    this.loginButtonOptions = {
      text: 'Login',
      icon: 'user',
      hint: 'Login',
      onClick: () => {
        this.showLoginDialog = true;
        this.errorMsg = '';
        this.showErrorMsg = false;
      }
    };

    this.userSettingsButtonOptions = {
      icon: 'user',
      stylingMode: 'text',
      width: 64,
      useSelectMode: false,
      dropDownOptions: { width: 200 },
      items: this.userSettingsDropdownItems,
      hint: 'User Management',
      onSelectionChanged: (e) => {
    
      },
      onItemClick: (e) => {
        if (e.itemData == this.userSettingsDropdownItems[this.changePasswordIndex]) {
          this.isForcedChangePassword = false;
          this.showChangePasswordDialog = true;
        }
      }
    };

    this.InitializeLogOffButton();
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  }

  aboutClicked = () => {
    alert('about clicked');
  }

  enterWorksheetDataClicked = () => {
    alert('enterWorksheetDataClicked');
  }

  enterViewDiagnosisClicked = () => {
    alert('enterViewDiagnosisClicked');
  }

  onViewItemClicked(e) {
    console.log('onViewItemClicked');
  }

  onLoginEnterKey(e){
    document.getElementById('login-submit-button').click();
  }

  onLoginClicked(e) {
    const ret = e.validationGroup.validate();

    if (ret.isValid) {
      this.formItemControlService.login(this.userModel.username, this.userModel.password, this, this.loginCallback);

      if (e.validationGroup != null) {
        e.validationGroup.reset();
      }
    }
  }

  loginCallback(context: any, status: boolean, msg: string) {
    if (context != null) {
      if (status) {
        context.userModel.username = '';
        context.userModel.password = '';
        context.showLoginDialog = false;
        context.showErrorMsg = false;
      } else {
        context.showErrorMsg = true;
        context.errorMsg = msg;
      }
    }
  }

  InitializeLogOffButton() {
    this.logoffButtonOptions = {
      text: 'Log Off ' + this.loggedInUser,
      icon: 'close',
      hint: 'Log Off',
      onClick: (e) => {
        this.formItemControlService.logoff();

        this.errorMsg = '';
        this.userModel.username = '';
        this.userModel.password = '';
        this.showLoginDialog = false;
        this.showErrorMsg = false;

        if (e.validationGroup != null) {
          e.validationGroup.reset();
        }
      }
    };
  }

  onCancelClicked(e) {
    this.errorMsg = '';
    this.userModel.username = '';
    this.userModel.password = '';
    this.showLoginDialog = false;
    this.showErrorMsg = false;

    const elt = document.getElementById('login-validation-group');
    //if (elt != null) {
    //  elt.validationGroup.reset();
    //}
  }

  onResetPasswordEnterKey(e){
    document.getElementById('reset-password-submit-button').click();
  }

  onResetPasswordClicked(e) {
    const ret = e.validationGroup.validate();

    this.showErrorMsg = false;
    this.errorMsg = '';

    if (this.resetPasswordModel.newPassword != this.resetPasswordModel.confirmPassword) {
      this.errorMsg = "The new password and confirm passwords do not match."
      this.showErrorMsg = true;
      return;
    }

    // validate the password
    let bPasswordValid = false;

    const decimal=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
    if (this.resetPasswordModel.newPassword.match(decimal)) {
      bPasswordValid = true;
    }

    if (bPasswordValid) {
     this.formItemControlService.resetPassword(this.resetPasswordModel,
                                                  this, 
                                                  this.resetPasswordCallback);

      if (e.validationGroup != null) {
        e.validationGroup.reset();
      }
    } else {
      this.errorMsg = "The new password must be between 8-15 characters and include at least one uppercase, one lowercase, one number, and one special character.";
      this.showErrorMsg = true;
    }
  }

  onCancelResetPasswordClicked(e) {
    this.errorMsg = '';
    this.showChangePasswordDialog = false;

    const elt = document.getElementById('login-validation-group');
    //if (elt != null) {
    //  elt.validationGroup.reset();
    //}
  }

  resetPasswordCallback(context: any, status: boolean, msg: string) {
    if (context != null) {
      if (status) {
        context.resetPasswordModel.userName = '';
        context.resetPasswordModel.oldPassword = '';
        context.resetPasswordModel.newPassword = '';
        context.resetPasswordModel.confirmPassword = '';
        context.showChangePasswordDialog = false;
        context.showErrorMsg = false;
      } else {
        context.showErrorMsg = true;
        context.errorMsg = msg;
      }
    }
  }

  isWorksheetLoaded() {
    let bRet = false;

    if (!this.isLoggedIn) {
      return bRet;
    }

    const worksheet = this.formItemControlService.getCurrentWorksheet();

    if (worksheet != null) {
      bRet = true;
    }
    
    return bRet;
  }

  populateViewMenu(bSupportsResults: boolean) {
    this.bSupportResultsLayout = bSupportsResults;

    if (this.bSupportResultsLayout) {
      this.viewMenuItems = [
        {
          id: formLayoutEnum.DiagnosisHorizontal,
          text: '2 Panel Horizontal'
        },
        {
          id: formLayoutEnum.DiagnosisVertical,
          text: '2 Panel Vertical'
        },
        {
          id: formLayoutEnum.Worksheet,
          text: 'Worksheet Only'
        },
        {
          id: formLayoutEnum.Diagnosis,
          text: 'Diagnosis Only'
        }
       ];
    } else {
      this.viewMenuItems = [
        {
          id: formLayoutEnum.DiagnosisHorizontal,
          text: '2 Panel Horizontal'
        },
        {
          id: formLayoutEnum.DiagnosisVertical,
          text: '2 Panel Vertical'
        },
        {
          id: formLayoutEnum.Worksheet,
          text: 'Worksheet View'
        },
        {
          id: formLayoutEnum.Diagnosis,
          text: 'Diagnosis View'
        }
       ];
    }

    if (this.bSupportResultsLayout) {
      this.selectBoxOptions = {
        width: 170,
        items: this.viewMenuItems,
        valueExpr: 'id',
        displayExpr: 'text',
        value: formLayoutEnum.DiagnosisHorizontal,
        placeholder: 'Select View',
        onValueChanged: (e) => {
          this.formItemControlService.setFormLayoutObservable(e.value);
        }
      };

      this.formItemControlService.setFormLayoutObservable(formLayoutEnum.DiagnosisHorizontal);
    } else {
      this.selectBoxOptions = {
        width: 170,
        items: this.viewMenuItems,
        valueExpr: 'id',
        displayExpr: 'text',
        value: formLayoutEnum.DiagnosisHorizontal,
        placeholder: 'Select View',
        onValueChanged: (e) => {
          this.formItemControlService.setFormLayoutObservable(e.value);
        }
      };

      this.formItemControlService.setFormLayoutObservable(formLayoutEnum.DiagnosisHorizontal);
    }
  }

}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    DxDropDownButtonModule,
    UserPanelModule,
    DxToolbarModule,
    DxPopupModule,
    DxTextBoxModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxFormModule
  ],
  declarations: [ HeaderComponent ],
  exports: [ HeaderComponent ]
})
export class HeaderModule { }
